export default "__VITE_ASSET__B5GU4cN4__"